import classes from "./css/ImageOnGrid.module.css";

const ImageOnGrid = (props) => {
  return (
    <>
      {props.image && (
        <button
          className={`${classes.main_image_detail} ${
            props.type === "dionisiache" ? classes.dionisiache : null
          }`}
          onClick={props.onClick}
        >
          <div
            style={{ backgroundImage: `url(${props.image})` }}
            className={`${classes.image_detail} ${
              props.type === "dionisiache" ? classes.dionisiache : null
            }`}
          />
        </button>
      )}
    </>
  );
};

export default ImageOnGrid;
